import React, { useMemo } from "react";
import {
  Table,
  Space,
  Button,
  Tag
} from '@lockerpm/design';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import itemsComponents from "../../../../../components/items";
import commonComponents from "../../../../../components/common";

import {
  convertDateTime,
  projectMemberRole,
  getEnvironment
} from '../../../../../secrets-web/src/utils/common'

import {
  DeleteOutlined,
  EditOutlined
} from "@ant-design/icons";

const TableData = (props) => {
  const { TextCopy } = itemsComponents;
  const { OnboardingTooltip } = commonComponents;

  const { t } = useTranslation()
  const userInfo = useSelector((state) => state.auth.userInfo);

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    environments = [],
    onUpdate = () => {},
    onDelete = () => {}
  } = props;

  const columns = useMemo(() => {
    return [
      {
        title: t('common.no'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 80,
      },
      {
        title: t('common.email'),
        dataIndex: 'email',
        key: 'email',
        align: 'left',
        width: 300,
        render: (_, record) => <TextCopy
          value={record.organization_member?.email || record.organization_member?.user?.email}
        />
      },
      {
        title: t('common.role'),
        dataIndex: 'role',
        key: 'role',
        align: 'center',
        width: 300,
        render: (_, record) => {
          const role = projectMemberRole(record.role)
          return <Tag
            color={role?.color}
          >
            <TextCopy
              value={t(role?.label)}
            />
          </Tag>
        }
      },
      {
        title: t('member.access_environment'),
        dataIndex: 'access_environments',
        key: 'access_environments',
        align: 'left',
        width: 350,
        render: (_, record) => {
          const envs = [{}, ...(record.access_environments || [])].map((env) => getEnvironment(env.environment_id, environments))
          return <Space size={[0, 8]} wrap className="w-[90%]">
            {
              envs.map((env, index) => <OnboardingTooltip
                title={env.key ? t('onboarding.env_all_default') : ''}
                placement="top"
                key={index}
                content={
                  <Tag
                    color={env.color}
                  >
                    <TextCopy
                      value={env?.name}
                    />
                  </Tag>
                }
              />)
            }
          </Space>
        }
      },
      {
        title: t('common.access_date'),
        dataIndex: 'access_date',
        key: 'access_date',
        align: 'center',
        width: 250,
        render: (_, record) => <TextCopy
          value={convertDateTime(record.access_date)}
          align={'center'}
        />
      },
      {
        title: t('common.actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'right',
        fixed: 'right',
        width: 100,
        render: (_, record) => (
          <>
            {
              (record.organization_member?.email || record.organization_member?.user?.email) !== userInfo?.username &&  <Space size={[8, 8]}>
                <Button
                  icon={<EditOutlined />}
                  type={'link'}
                  onClick={() => onUpdate(record)}
                />
                <Button
                  icon={<DeleteOutlined />}
                  type={'link'}
                  danger
                  onClick={() => onDelete(record)}
                />
              </Space>
            }
          </>
        ),
      },
    ].filter((c) => !c.hide)
  }, [userInfo])

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      size="small"
      sortDirections={['ascend', 'descend']}
      scroll={{ x: 1024 }}
    />
  );
}

export default TableData;
